import { Form } from 'react-bootstrap';
import { ALL_USERS_PERMISSIONS } from '../../../config/roles';
import * as PropTypes from 'prop-types';

import { T, useTranslate } from '@tolgee/react';

const PermissionsRadioInputsSectionTwo = ({
  watch,
  register,
  error,
  setPermissionsError,
  userUpdate = false,
  uuid = null
}) => {
  const { t } = useTranslate();

  const updatePermission = (e) => {
    // remove on toggle update
    //   if (!userUpdate) return;
    //
    //   dispatch(
    //     updateInvite(
    //       { uuid, [e.target.name]: e.target.checked },
    //       () => {},
    //       updatePermissionsSuccessCallback
    //     )
    //   );
  };

  return (
    <div className="pt-3 mt-3">
      <h2>{t('invite.createForm.all_users_permissions')}</h2>
      {Object.keys(ALL_USERS_PERMISSIONS).map((permission) => (
        <div
          className={`d-flex gap-3 justify-content-between pt-4`}
          key={ALL_USERS_PERMISSIONS[permission].name}
        >
          <div>
            <h5>
              {t(`config.roles.${ALL_USERS_PERMISSIONS[permission].name}`)}
            </h5>
            <p className="text-gray-400 fw-semibold d-block fs-7">
              <T keyName={ALL_USERS_PERMISSIONS[permission].description} />
            </p>
          </div>
          <Form.Check
            type="switch"
            id="disabled-custom-switch"
            className="color-primary"
            {...register(ALL_USERS_PERMISSIONS[permission].key)}
            onClick={updatePermission}
            name={ALL_USERS_PERMISSIONS[permission].key}
            checked={watch(ALL_USERS_PERMISSIONS[permission].key)}
            defaultChecked={
              !userUpdate || watch(ALL_USERS_PERMISSIONS[permission].key)
            } // Set defaultChecked attribute to true
          />
        </div>
      ))}
    </div>
  );
};
PermissionsRadioInputsSectionTwo.propTypes = {
  watch: PropTypes.any,
  setPermissionsError: PropTypes.any,
  register: PropTypes.any,
  error: PropTypes.any,
  userUpdate: PropTypes.bool,
  uuid: PropTypes.any
};

export default PermissionsRadioInputsSectionTwo;
